/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import hoistStatics from "hoist-non-react-statics";
import { Redirect } from "react-router-dom";
import Spinner from "./Spinners/BrandSpinner";

export function isProfileComplete(profile) {
  return (
    profile != null &&
    profile.currency != null &&
    profile.currency !== "" &&
    profile.email != null &&
    profile.email !== "" &&
    (profile.sub0 === "ml_01en_2" || profile.phone != null)
  );
}


function mapStateToProps(state) {
  const s = state.dataRequirementsStatus;
  const p = state.profile;

  return {
    isAvailable: ["profile", "serverData", "settings"].every(
      key => s[key] === "AVAILABLE" || state[key] !== null
    ),
    isInvalid: s.profile === "INVALID",
    profile: p
  };
}

export default function Private(WrappedComponent: React.ComponentType<*>) {
  let stock;

  function C({ isAvailable, isInvalid, profile, ...props }) {
    if (isAvailable) {
      if (isProfileComplete(profile)) {
        if (props.stock) {
          stock = props.stock;
        }

        const C = <WrappedComponent {...props} stock={stock} />;
        stock = null;
        return C;
      } else {
        stock = props.stock;
        const urlParams = window.location.search || "";
        const to = process.env.REACT_APP_PROJECT === "app" ? "/login" : "/";
        return <Redirect to={`${to}${urlParams}`} />;
      }
    } else if (isInvalid) {
      stock = props.stock;
      let urlParams = window.location.search || "";
      const pathname = window.location.pathname + urlParams;
      if (pathname) {
        if (urlParams) {
          urlParams += `&redirect=${encodeURIComponent(pathname)}`;
        } else {
          urlParams = `?redirect=${encodeURIComponent(pathname)}`;
        }
      }


      const to = process.env.REACT_APP_PROJECT === "app" ? "/login" : "/";
      return <Redirect to={`${to}${urlParams}`} />;
    } else {
      return <Spinner />;
    }
  }

  C.displayName = `Private(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  return connect(mapStateToProps)(hoistStatics(C, WrappedComponent));
}

export function Public(WrappedComponent: React.ComponentType<*>) {
  function C({ isAvailable, isInvalid, ...props }) {
    if (isAvailable) {
      return <WrappedComponent {...props} />;
    } else {
      return <Spinner />;
    }
  }

  C.displayName = `Private(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  return connect(mapStateToProps)(hoistStatics(C, WrappedComponent));
}



// WEBPACK FOOTER //
// ./src/components/Private.js